import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAgile from 'vue-agile'
import axios from './axios'
import store from './store'
import loader from "vue-ui-preloader"
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import vueDebounce from 'vue-debounce'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import moment from 'moment'
import VCalendar from 'v-calendar'
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'
const VueInputMask = require('vue-inputmask').default
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import Vue2TouchEvents from 'vue2-touch-events'
import VueYandexMetrika from 'vue-yandex-metrika'

moment.locale('ru')

Vue.prototype.$http = axios
Vue.prototype.$moment = moment
Vue.prototype.$api = require('./api').default
Vue.prototype.$eventHub = new Vue()

Vue.use(vueDebounce)
Vue.use(VueLodash, {lodash})
Vue.use(loader)

Vue.use(CoolLightBox)
Vue.use(vueDebounce)
Vue.use(VueLodash, {lodash})
Vue.use(loader)
Vue.use(VueAgile)
Vue.use(Vue2TouchEvents)
Vue.use(VCalendar)
Vue.use(Toast, {
  timeout: 2500,
  position: "bottom-left"
})
Vue.use(VueCustomTooltip, {
  name: 'VueCustomTooltip',
  color: '#fff',
  background: '#000',
  borderRadius: 12,
  fontWeight: 400,
})
Vue.use(VueInputMask)
Vue.config.productionTip = false

Vue.use(VueYandexMetrika, {
  id: 72367186,
  router: router,
  env: 'production'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
